import { render, staticRenderFns } from "./modal-password.vue?vue&type=template&id=10f309d6&scoped=true&"
import script from "./modal-password.vue?vue&type=script&lang=js&"
export * from "./modal-password.vue?vue&type=script&lang=js&"
import style0 from "./modal-password.vue?vue&type=style&index=0&id=10f309d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f309d6",
  null
  
)

export default component.exports